/**
 * Normalize alert currency/token symbols into standardized trading pairs
 */
export const ensureUsdtSymbol = (currency: string): string => {
  if (!currency) {
    return '';
  }

  const normalized = currency.replace('/', '').trim().toUpperCase();
  if (normalized.endsWith('USDT')) {
    return normalized;
  }

  return `${normalized}USDT`;
};

export const extractBaseCurrency = (symbol: string): string => {
  if (!symbol) {
    return '';
  }
  return symbol.replace(/USDT|USDM|PERP/gi, '').toUpperCase();
};

/**
 * Remove USDT suffix from a symbol
 * Alias for extractBaseCurrency for better readability
 */
export const removeUsdtSuffix = extractBaseCurrency;

